import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import * as wjCore from "wijmo/wijmo";
import * as wjGrid from "wijmo/wijmo.grid";
import * as wjInput from "wijmo/wijmo.input";
import {UtilService} from "@app/modules/shared/services/util.service";
import {KlPreferenceSaveFormComponent} from "@app/modules/shared/components/preference-form/kl-preference-save-form.component";
import {ApiService} from "@app/modules/shared/services/base/api.service";
import {KlSweetAlertService} from "@app/modules/shared/services/message/kl-sweet-alert.service";
import {ExportType} from "@app/data/shared/enums/export-type.enum";
import {BaseFilter} from "@app/data/shared/models/base-filter";
import {InitState} from "@app/modules/shared/components/grid/grid.component";
import {FilterableItem} from "@app/data/shared/models/filterable-item";
import {ExplorerService} from "@app/modules/shared/services/explorer.service";
import {Subscription} from "rxjs/Subscription";
import {ToastService} from "@app/modules/shared/services/message/toast.service";
import {findIndex} from "lodash";
import {BsDropdownDirective} from "ngx-bootstrap/dropdown";
import {TranslateService} from "@app/modules/shared/services/translate/translate.service";
import {ActionDto} from "@app/modules/shared/model/action.dto";
import {FlexGridFilter} from "wijmo/wijmo.grid.filter";
import {ConvertIsoDateService} from "../../services/convert-iso-date.service";

@Component({
  selector: "kl-grid-container",
  templateUrl: "./grid-container.component.html",
  styleUrls: ["./grid-container.component.scss"],
})
export class GridContainerComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @ViewChild("flexGrid", {static: true}) flexGrid: wjGrid.FlexGrid;
  // @ViewChild('flexGrid') flexGrid: GridComponent;
  @ViewChild("listGridMenu", {static: true}) listGridMenu: any;
  @ViewChild("toolbarList", {static: true}) toolbarList: ElementRef;
  @ViewChild("gridDropDownMenu", {static: true}) gridDropDownMenu: ElementRef;
  @ViewChild("gridDropDownMenu", {static: true}) dp: BsDropdownDirective;
  @ViewChild(forwardRef(() => KlPreferenceSaveFormComponent), {
    static: true,
  })
  klPreferenceSaveFormComponent: any;
  @ViewChild("filterForm", {static: true}) filterForm: ElementRef;
  @ViewChild("flexGridFilterEl") flexGridFilterEl: FlexGridFilter;

  // inputs
  @Input() parentModuleName: string;
  @Input() moduleName: string;
  @Input() gridName: string;
  @Input() fastFilterName: string;
  @Input() collectionView: wjCore.CollectionView;
  @Input() showButton = true;
  @Input() authGroupShow = true;
  @Input() disabledButton: boolean;
  @Input() deferResizing: boolean;
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() authGroupList: Array<any> = [];
  @Input() columns: Array<any> = [];
  @Input() filterObject: any;
  @Input() sortable: boolean;
  @Input() filterSelectItems: FilterableItem[] = [];
  @Input() initStatesWithoutChild: Array<InitState>;
  @Input() initStatesWithChild: Array<InitState>;
  @Input() gridHeaderName: string;
  @Input() specialType: string;
  @Input() filterable: boolean;
  @Input() customFilter: any;
  @Input() fastFilterObject: any;
  @Input() pageSize = 10;
  @Input() minCount = 1;
  @Input() maxCount = 1000;
  @Input() exportable: boolean;
  @Input() actions: Array<ActionDto>;
  @Input() processesActions: Array<ActionDto>;
  @Input() customToolbar: Array<ActionDto>;
  @Input() showToolbar = true;
  @Input() textToFilter: string;
  @Input() alertType: string;
  @Input() alertMessage: string;
  @Input() alertShow: boolean;
  @Input() doAdd = true;

  // outputs
  @Output() onEditCell = new EventEmitter<any>();
  @Output() onDblClickEditCell = new EventEmitter<any>();
  @Output() onViewCell = new EventEmitter<any>();
  @Output() onDeleteCell = new EventEmitter<any>();
  @Output() onInfoCell = new EventEmitter<any>();
  @Output() onFilter = new EventEmitter<any>();
  @Output() onCustomFilter = new EventEmitter<any>();
  @Output() onNew = new EventEmitter<BaseFilter<any>>();
  @Output() onSortable = new EventEmitter<BaseFilter<any>>();
  @Output() onExport = new EventEmitter<ExportType>();
  @Output() onCloseAlert = new EventEmitter<ExportType>();
  @Output() onRefresh = new EventEmitter<ExportType>();

  _currentItem: any;
  subscription: Subscription;

  currentColumnData: Array<any>;
  defaultTemplate: any;
  currentTemplate: any;
  columnLayout = [];
  defaultColumns = [];
  layout: any;
  index = 0;
  templates = [];
  layoutId: string;

  rightToLeft = false;
  isTemplatesOpen = false;
  isSidebarShow = false;
  bodyElement: any;

  setSavedFilter = false;
  setDefaultFilter = false;
  showFilterContainer = false;
  filterType: any;
  isCollapsed: boolean;
  filterExpression = "LIKE";
  isFilterButtonDisabled: boolean;

  saveForm = false;

  set currentItem(item) {
    this._currentItem = item;
  }

  get currentItem() {
    this._currentItem = this.collectionView
      ? this.collectionView.currentItem
        ? this.collectionView.currentItem
        : this.collectionView.sourceCollection[0]
      : {};
    return this._currentItem;
  }

  constructor(
    private utilService: UtilService,
    private sweetAlertService: KlSweetAlertService,
    private toastService: ToastService,
    private explorerService: ExplorerService,
    private translateService: TranslateService,
    private renderer: Renderer2,
    private changeDetector: ChangeDetectorRef,
    private apiService: ApiService,
    private convertIsoDateService: ConvertIsoDateService
  ) {
    this.subscription = explorerService.menuCollapseStream$.subscribe(() => {
      if (this.flexGrid) {
        this.flexGrid.refresh(true);
      }
    });
  }

  ngOnInit() {
    this.defaultColumns = UtilService.deepCopy(this.columns);
    this.bodyElement = document.querySelector("body");
    this.flexGrid.rows.defaultSize = 30;
    this.flexGrid.columnHeaders.rows.defaultSize = 30;
    this.flexGrid.selectionChanged.addHandler((flexGrid, event: any) => {
      this.currentItem = this.collectionView.sourceCollection[event.row];
    });
    this.flexGrid.addEventListener(
      this.flexGrid.hostElement,
      "contextmenu",
      (e: any) => {
        if (!this.disabledButton && this.showButton) {
          const ht = this.flexGrid.hitTest(e);
          this.currentItem =
            ht.row >= 0
              ? this.flexGrid.rows[ht.row].dataItem
              : this.flexGrid.selectedItems[0];
        } else {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
    this.flexGrid.hostElement.addEventListener("mousedown", (event: any) => {
      const ht = this.flexGrid.hitTest(event);
      this.currentItem =
        ht.row >= 0
          ? this.flexGrid.rows[ht.row].dataItem
          : this.flexGrid.selectedItems[0];
    });
    if (this.gridName) {
      let commitObject: any;
      commitObject = {
        parent: {
          module: this.parentModuleName,
        },
        module: this.moduleName,
        key: this.gridName,
        type: "GRID_DESIGN",
      };
      this.apiService.getFilteredData("design", commitObject).subscribe(
        (resPreference) => {
          if (resPreference.data.length > 0) {
            for (let i = 0; i < resPreference.data.length; i++) {
              if (resPreference.data[i].level_default === "DEFAULT") {
                this.index = i;
                this.currentTemplate = {
                  layout: JSON.parse(resPreference.data[i].content),
                  description: resPreference.data[i].description,
                  id: resPreference.data[i].id,
                  level: resPreference.data[i].level,
                  level_default: resPreference.data[i].level_default,
                };
                this.defaultTemplate = JSON.parse(
                  resPreference.data[i].content
                ).columns;
                this.columns = UtilService.deepCopy(this.defaultTemplate);
                this.flexGrid.refresh(true);
              }
              this.templates.push({
                layout: JSON.parse(resPreference.data[i].content),
                description: resPreference.data[i].description,
                id: resPreference.data[i].id,
                level: resPreference.data[i].level,
                level_default: resPreference.data[i].level_default,
              });
            }
          }
        },
        (errPreference) => this.handleError(errPreference)
      );
    }
  }

  ngAfterViewInit() {
    let longClickTimer,
      longPress = false;
    this.flexGrid.hostElement.addEventListener(
      "touchstart",
      () => {
        const userAgent = window.navigator.userAgent;
        if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
          longClickTimer = setTimeout(() => {
            longPress = true;
          }, 500);
        }
      },
      true
    );
    this.flexGrid.hostElement.addEventListener(
      "touchend",
      () => {
        clearTimeout(longClickTimer);
      },
      true
    );
    this.flexGrid.hostElement.addEventListener("click", (e) => {
      const contextMenu = <wjInput.Menu>(
        wjCore.Control.getControl("#list-grid-context-menu")
      );
      if (longPress && this.showButton) {
        longPress = false;
        let ht: wjGrid.HitTestInfo;
        ht = this.flexGrid.hitTest(e);
        if (ht && ht.cellType === wjGrid.CellType.Cell) {
          this.currentItem = ht.grid.rows[ht.row].dataItem;
          contextMenu.isDroppedDown = true;
          const contextMenuList = <HTMLDivElement>(
            document.querySelector("#list-grid-context-menu_dropdown")
          );
          this.showContextMenu(
            contextMenuList,
            e,
            new wjCore.Point(e.pageX + 10, e.pageY + 10)
          );
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.showButton) {
      if (this.fastFilterObject) {
        if (!this.setSavedFilter) {
          const fastFilterObject = JSON.parse(this.fastFilterObject.content);
          let index = findIndex(this.filterSelectItems, {
            name: fastFilterObject.parameters[0].name,
          });
          if (index === -1) {
            index = findIndex(this.filterSelectItems, {
              name: fastFilterObject.parameters[0].name,
            });
          }
          this.filterType =
            index !== -1
              ? this.filterSelectItems[index]
              : this.filterSelectItems
              ? this.filterSelectItems[0]
              : null;
          this.filterExpression =
            fastFilterObject.parameters[0].expression.operator;
          this.pageSize = fastFilterObject.query.paging.limit;
          this.setSavedFilter = true;
        }
      } else {
        if (!this.setDefaultFilter) {
          this.filterType = this.filterSelectItems
            ? this.filterSelectItems[0]
            : null;
          this.setDefaultFilter = true;
        }
      }
    }
  }

  editingFilter(flexGridFilter, event: wjGrid.CellRangeEventArgs) {
    flexGridFilter.getColumnFilter(event.col).valueFilter.maxValues = 100000;
    if (this.columns[event.col].format) {
      if (this.columns[event.col].format.includes("date")) {
        flexGridFilter.getColumnFilter(event.col).dataMap = new wjGrid.DataMap(
          this.collectionView.sourceCollection
            .filter((line) => line[this.columns[event.col].binding])
            .map((line) => {
              if (line[this.columns[event.col].binding]) {
                return {
                  value: line[this.columns[event.col].binding],
                  caption:
                    this.columns[event.col].format === "date"
                      ? this.convertIsoDateService.makeDate(
                          new Date(line[this.columns[event.col].binding]),
                          this.utilService.dateFormatString
                        )
                      : this.convertIsoDateService.convertDateAndTime(
                          new Date(line[this.columns[event.col].binding]),
                          this.utilService.dateFormatString
                        ),
                };
              }
            }),
          "value",
          "caption"
        );
      }
    } else if (this.columns[event.col].translate) {
      const dataMap = new wjGrid.DataMap(
        this.collectionView.sourceCollection.map((line) => {
          return {
            value: line[this.columns[event.col].binding],
            caption: this.translateService.instant(
              line[this.columns[event.col].binding]
            ),
          };
        }),
        "value",
        "caption"
      );
      flexGridFilter.getColumnFilter(event.col).dataMap = dataMap;
    }
  }

  onFilterChanged() {
    const filterState = this.flexGridFilterEl.filterDefinition;
    const filterObj = JSON.parse(filterState);
    if (filterObj?.filters.length > 0) {
      for (let filter of filterObj.filters) {
        filter.showValues = Object.keys(filter.showValues).reduce(
          (acc, key) => {
            const newKey = this.translateService.backInstant(key);
            if (newKey) {
              acc[newKey] = filter.showValues[key];
            }
            return acc;
          },
          {}
        );
      }
    }

    localStorage.setItem("myFilterState", JSON.stringify(filterObj));
  }

  calculateFromArray(data, binding): number {
    let _sum = 0;
    const prepareBinding = binding.split(".");
    data[prepareBinding[0]].forEach((line) => {
      _sum = _sum + line[prepareBinding[1]];
    });
    return _sum;
  }

  stringTimeConvert(time) {
    return new Date(new Date().toDateString() + " " + time);
  }

  openSidebar() {
    this.isSidebarShow = true;
  }

  refresh() {
    this.onRefresh.emit();
  }

  private showContextMenu(
    contextMenu: HTMLElement,
    e: any,
    point: wjCore.Point
  ) {
    let posX = (point ? point.x : e.clientX) + (e ? window.pageXOffset : 0),
      posY = (point ? point.y : e.clientY) + (e ? window.pageYOffset : 0);
    contextMenu.style.position = "absolute";
    contextMenu.style.display = "inline";
    if (posY + contextMenu.clientHeight > window.innerHeight) {
      posY -= contextMenu.clientHeight;
    }
    if (posX + contextMenu.clientWidth > window.innerWidth) {
      posX -= contextMenu.clientWidth;
    }
    contextMenu.style.top = posY + "px";
    contextMenu.style.left = posX + "px";
  }

  deleteLayout(template, index) {
    this.sweetAlertService.alert(
      {
        title: "Uyarı",
        text: "Kayıt Silinecektir",
        customClass: "kl-alert",
        showCloseButton: false,
      },
      () => {
        this.apiService.deleteData("design", template.id).subscribe(
          () => {
            this.templates.splice(index, 1);
            this.setDefaultTemplate();
          },
          (errPreference) => this.handleError(errPreference)
        );
      },
      () => {}
    );
  }

  setDefaultTemplate() {
    this.currentTemplate = null;
    this.columns = UtilService.deepCopy(this.defaultColumns);
    this.flexGrid.refresh(true);
  }

  selectLayout(template, index) {
    this.currentTemplate = template;
    this.index = index;
    this.currentColumnData = [];
    template.layout.columns.forEach((column) => {
      for (let i = 0; i < this.defaultColumns.length; i++) {
        if (column.binding === this.defaultColumns[i].binding) {
          this.currentColumnData.push(this.defaultColumns[i]);
          Object.assign(
            this.currentColumnData[this.currentColumnData.length - 1],
            {visible: column.visible}
          );
        }
      }
    });
    this.columns = [];
    this.columns = UtilService.deepCopy(this.currentColumnData);
  }

  saveLayout(mode, currentTemplate?, index?) {
    this.layoutId = currentTemplate ? currentTemplate.id : null;
    this.index = index;
    this.klPreferenceSaveFormComponent.show(mode, "design", currentTemplate);
  }

  commitSave(event: any) {
    this.saveForm = true;
    let commitObject: any;
    this.columnLayout = [];
    for (let i = 0; i < this.flexGrid.columns.length; i++) {
      for (let j = 0; j < this.defaultColumns.length; j++) {
        if (
          this.flexGrid.columns[i].binding === this.defaultColumns[j].binding
        ) {
          const obj = Object.assign(this.defaultColumns[j], {
            visible: this.flexGrid.columns[i].visible,
          });
          this.columnLayout.push(obj);
        }
      }
    }
    this.columns = UtilService.deepCopy(this.columnLayout);
    commitObject = {
      parent: {
        module: this.parentModuleName,
      },
      level: event.levelStatus ? "APPLICATION" : "USER",
      level_default: event.levelDesign ? "DEFAULT" : "NO_DEFAULT",
      description: event.entryName,
      module: this.moduleName,
      key: this.gridName,
      type: "GRID_DESIGN",
      content: JSON.stringify({columns: this.columns}),
    };
    switch (event.commitType) {
      case "add":
        this.apiService.addData("design", commitObject).subscribe(
          (resPreference) => {
            this.saveForm = false;
            this.currentTemplate = UtilService.deepCopy({
              layout: JSON.parse(resPreference.content),
              description: resPreference.description,
              id: resPreference.id,
              level: resPreference.level,
              level_default: resPreference.level_default,
            });
            this.templates.push({
              layout: JSON.parse(resPreference.content),
              description: resPreference.description,
              id: resPreference.id,
              level: resPreference.level,
              level_default: resPreference.level_default,
            });
            this.selectLayout(this.currentTemplate, this.templates.length - 1);
            this.klPreferenceSaveFormComponent.hide();
          },
          (errPreference) => {
            this.saveForm = false;
            this.handleError(errPreference);
          }
        );
        break;
      case "edit":
        commitObject["id"] = this.layoutId;
        this.apiService.updateData("design", commitObject).subscribe(
          (resPreference) => {
            this.saveForm = false;
            if (resPreference) {
              this.templates[this.index].description =
                resPreference.description;
              this.templates[this.index].layout = JSON.parse(
                resPreference.content
              );
              this.templates[this.index].id = resPreference.id;
              this.templates[this.index].level = resPreference.level;
              this.templates[this.index].level_default =
                resPreference.level_default;
              this.selectLayout(this.templates[this.index], this.index);
              this.klPreferenceSaveFormComponent.hide();
            }
          },
          (errPreference) => {
            this.saveForm = false;
            this.handleError(errPreference);
          }
        );
        break;
    }
  }

  explorerDblClickEdit() {
    if (this.isShow(this.tabId + ".002")) {
      if (this.hasProperty(this.currentItem, "id")) {
        this.onDblClickEditCell.emit(this.currentItem);
      }
    } else {
      this.handleError("not_authorized_to_perform_this_operation");
    }
  }

  openNew(type?: any) {
    if (this.isShow(this.tabId + ".001")) {
      type ? this.onNew.emit(type) : this.onNew.emit();
    } else {
      this.handleError("not_authorized_to_perform_this_operation");
    }
  }

  explorerEdit() {
    if (this.isShow(this.tabId + ".002")) {
      if (this.hasProperty(this.currentItem, "id")) {
        this.onEditCell.emit(this.currentItem);
      }
    } else {
      this.handleError("not_authorized_to_perform_this_operation");
    }
  }

  explorerView() {
    if (this.isShow(this.tabId + ".003")) {
      if (this.hasProperty(this.currentItem, "id")) {
        this.onViewCell.emit(this.currentItem);
      }
    } else {
      this.handleError("not_authorized_to_perform_this_operation");
    }
  }

  explorerDelete() {
    if (this.isShow(this.tabId + ".004")) {
      if (this.hasProperty(this.currentItem, "id")) {
        this.onDeleteCell.emit(this.currentItem);
      }
    } else {
      this.handleError("not_authorized_to_perform_this_operation");
    }
  }

  explorerInfo() {
    if (this.isShow(this.tabId + ".005")) {
      if (this.hasProperty(this.currentItem, "id")) {
        this.onInfoCell.emit(this.currentItem);
      }
    } else {
      this.handleError("not_authorized_to_perform_this_operation");
    }
  }

  hasProperty(item, key) {
    return this.utilService.hasProperty(item, key);
  }

  closeAlert() {
    this.alertShow = false;
    this.onCloseAlert.emit();
  }

  menuItemClicked(listGridMenu) {
    switch (listGridMenu.value) {
      case "edit":
        if (this.isShow(this.tabId + ".002")) {
          this.onEditCell.emit(this.currentItem);
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
        break;
      case "view":
        if (this.isShow(this.tabId + ".003")) {
          this.onViewCell.emit(this.currentItem);
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
        break;
      case "delete":
        if (this.isShow(this.tabId + ".004")) {
          this.onDeleteCell.emit(this.currentItem);
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
        break;
      case "do_info":
        if (this.isShow(this.tabId + ".005")) {
          this.onInfoCell.emit(this.currentItem);
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
        break;
      default:
        if (this.actions) {
          this.actions.forEach((action) => {
            if (action.slug === listGridMenu.value) {
              action.method({item: this.currentItem});
            }
          });
        }
        if (this.processesActions) {
          this.processesActions.forEach((action) => {
            if (action.slug === listGridMenu.value) {
              action.method({item: this.currentItem});
            }
          });
        }
        break;
    }
  }

  isShow(id: string): boolean {
    return this.utilService.isShow(id);
  }

  changeCheckBox(event, cellItem) {
    if (cellItem.hasOwnProperty("selected")) {
      cellItem.selected = event;
    } else {
      Object.assign(cellItem, {selected: event});
    }
  }

  openSortable() {
    this.onSortable.emit();
  }

  saveFastFilterLayout() {
    const filterInstance = this.prepareFilterObject();
    let commitObject = Object.create(null);
    commitObject = {
      parent: {
        module: this.parentModuleName,
      },
      module: this.moduleName,
      key: this.fastFilterName,
      level: "USER",
      level_default: "DEFAULT",
      description: this.fastFilterName,
      type: "FILTER",
      content: JSON.stringify(filterInstance),
    };
    if (this.fastFilterObject) {
      commitObject.id = this.fastFilterObject.id;
      this.apiService.updateData("design", commitObject).subscribe(
        () => {
          this.toastService.toastSuccess();
        },
        (error) => this.handleError(error)
      );
    } else {
      this.apiService.addData("design", commitObject).subscribe(
        () => {
          this.toastService.toastSuccess();
        },
        (error) => this.handleError(error)
      );
    }
  }

  submit() {
    const filterInstance = this.prepareFilterObject();
    this.onFilter.emit(filterInstance);
  }

  prepareFilterObject() {
    const filterInstance = {
      filter: this.filterObject ? UtilService.deepCopy(this.filterObject) : {},
      parameters: [],
      query: {
        paging: {
          limit: this.pageSize ? this.pageSize : 10,
          fetch: "EAGER",
        },
      },
    };
    if (this.filterType) {
      if (this.filterSelectItems) {
        if (this.filterType.objectKey) {
          if (this.filterType.type === "array") {
            const arrayObject = Object.create(null);
            if (this.textToFilter) {
              arrayObject[this.filterType.objectKey] = this.textToFilter;
            } else {
              arrayObject[this.filterType.objectKey] = "";
            }
            filterInstance.filter[this.filterType.name] = [arrayObject];
          } else {
            filterInstance.filter[this.filterType.name] = Object.create(null);
            if (this.textToFilter) {
              filterInstance.filter[this.filterType.name][
                this.filterType.objectKey
              ] = this.textToFilter;
            } else {
              filterInstance.filter[this.filterType.name][
                this.filterType.objectKey
              ] = "";
            }
          }
        } else {
          if (this.textToFilter) {
            filterInstance.filter[this.filterType.name] = this.textToFilter;
          } else {
            filterInstance.filter[this.filterType.name] = "";
          }
        }
      }
      if (this.filterExpression) {
        filterInstance.parameters.push({
          name: this.filterType.parameterName
            ? this.filterType.parameterName
            : this.filterType.name,
          expression: {operator: this.filterExpression},
        });
      }
    }
    return filterInstance;
  }

  exportAs(type) {
    this.onExport.emit(type);
  }

  customFilterOpen() {
    this.onCustomFilter.emit({customFilter: true, pageSize: this.pageSize});
  }

  toggleFilterContainer() {
    this.showFilterContainer = !this.showFilterContainer;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  handleError(error) {
    this.alertMessage = error;
    this.alertShow = true;
    this.alertType = "error";
  }
}
